import { useMutation as m } from "react-query";
import { useEnvironment as d } from "../../../common/hooks/environment/useEnvironment.js";
import { ProfileAdapter as l } from "../../models/customer/profile/profile.adapter.js";
import { ScopeAdapter as h } from "../../models/scope/scope.adapter.js";
import { getAdapter as c } from "../../adapter.js";
class k extends Error {
  constructor(o, r) {
    super(r), this.errorCode = o;
  }
}
function _() {
  const {
    backendBaseUrl: n
  } = d();
  return m(async (o) => {
    const {
      token: r,
      profile: s,
      scope: p,
      customTags: i,
      phoneVerificationToken: a
    } = o, f = c(l).serialize(s), u = c(h).serialize(p), e = await fetch(`${n}/contact/${s.externalId}/`, {
      method: "PUT",
      body: JSON.stringify({
        ...f,
        ...i ? { custom_tags: i } : {},
        ...a ? { phone_verification_token: a } : {},
        scope: u
      }),
      headers: {
        authorization: `Token ${r}`
      }
    });
    if (!e.ok) {
      const t = await e.json().catch(() => ({}));
      throw new k(
        (t == null ? void 0 : t.error_code) ?? "unknown",
        (t == null ? void 0 : t.detail) ?? `Request failed with status ${e.status}`
      );
    }
    return e.json();
  });
}
export {
  k as ContactUpdateError,
  _ as useUpdateContactInformation
};
//# sourceMappingURL=useUpdateContactInformation.js.map
